import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-skeleton-table',
  templateUrl: './skeleton-table.component.html',
  styleUrl: './skeleton-table.component.css'
})
export class SkeletonTableComponent {
  @Input() columnas?: number;
  @Input() filas: number = 6;

  @ViewChild('container')
  container!: ElementRef<HTMLDivElement>;

  /**
   * Altura aproximada de cada fila.
   */
  @Input() alturaFila = 35;

  /**
   * Altura aproximada del encabezado.
   */
  @Input() alturaHeader = 40;

  /**
   * Ancho mínimo que queremos para una columna.
   */
  @Input() anchoColumna = 200;

  columnasVisibles = 0;
  filasVisibles = 0;

  private resizeObserver?: ResizeObserver;

  ngAfterViewInit(): void {
    this.resizeObserver = new ResizeObserver(entries => {
      const element = entries[0]?.contentRect;

      if (!element) {
        return;
      }

      this.calcularDimensiones(
        element.width,
        element.height
      );
    });

    this.resizeObserver.observe(this.container.nativeElement);
  }

  private calcularDimensiones(
    ancho: number,
    alto: number
  ): void {
    if (this.columnas && this.columnas > 0) {
      this.columnasVisibles = this.columnas;
    } else {
      this.columnasVisibles = Math.max(
        1,
        Math.floor(ancho / this.anchoColumna)
      );
    }

    const altoDisponible = alto - this.alturaHeader;

    this.filasVisibles = Math.max(
      1,
      Math.floor(altoDisponible / this.alturaFila)
    );
  }

  get colArray() {
    return Array(this.columnasVisibles).fill(0);
  }

  get rowArray() {
    return Array(this.filasVisibles).fill(0);
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }
}
